/* eslint-disable */
import React from 'react'
import { pie, arc } from 'd3-shape'
import { scaleLinear } from 'd3-scale'
import { extent } from 'd3-array'
import countBy from 'lodash/countBy'
import find from 'lodash/find'
import LoadCounts from './Helpers/LoadCounts'
import Color from '../../Utilities/Colors/ColorMap'
import NetworkPieLegend from '../../Legend/NetworkPieLegend'
import Tooltip from '../../Tooltip/Tooltip'

const connections = [
    ['00', '01'],
    ['00', '10'],
    ['01', '02'],
    ['02', '12'],
    ['01', '11'],
    ['10', '11'],
    ['10', '20'],
    ['11', '12'],
    ['11', '21'],
    ['12', '22'],
    ['22', '32'],
    ['20', '30'],
    ['20', '21'],
    ['30', '31'],
    ['21', '22'],
    ['21', '31'],
    ['31', '32'],
]

export default function PieChart({ settings, chartOptions = {} }) {
    function handleMouseOver(event, tip) {
        Tooltip(event, settings, tip)
    }

    function handleMouseOut(event) {
        Tooltip(event, settings)
    }

    let counts = settings.data

    if (!chartOptions.skipDataProcess) {
        counts = LoadCounts(settings.data, chartOptions)
    }

    const pieChart = pie()
        .sort(null)
        .value((d) => d.total)

    const layerCount = countBy(counts, 'layer')

    const layers = []
    const maxCircleSize = 75
    const minCircleSize = 30

    let scaleHeight = 0.24

    if (settings.shape === 'twitter') {
        scaleHeight = 0.34
    }

    // Array to store location of cx for connecting lines
    const xyLocations = []
    const elements = []

    const scaleX = function (d) {
        const layer = d.layer.toString()

        if (!layers[layer] && layers[d.layer.toString()] != 0) {
            layers[layer] = 1
        } else {
            layers[layer]++
        }

        let widthCircle = settings.vizWidth / (layerCount[d.layer] + 1)
        widthCircle *= layers[layer]

        return widthCircle
    }

    const domain = extent(counts, (d) => {
        if (d.totalPitches > 0) {
            return d.totalPitches
        }
    })

    const scaleCircle = scaleLinear()
        .domain(domain)
        .range([minCircleSize, maxCircleSize])

    counts.map((count) => {
        let makeArc = arc()
            .innerRadius(0)
            .outerRadius(maxCircleSize / 2 - 1)

        if (chartOptions.scaleRadius) {
            makeArc = arc()
                .innerRadius(0)
                .outerRadius(scaleCircle(count.totalPitches) / 2 - 1)
        }

        const arcs = pieChart(count.children)
        const xLocation = scaleX(count)
        xyLocations.push({
            layer: count.name,
            x: xLocation + maxCircleSize / 2,
            y:
                count.layer * (settings.height * scaleHeight) +
                maxCircleSize / 2,
        })

        elements.push(
            <g
                key={`g_${count.name}`}
                transform={`translate(${xLocation}, ${
                    count.layer * (settings.height * scaleHeight)
                })`}
            >
                <text
                    x={maxCircleSize / 2}
                    y={-maxCircleSize * 0.03}
                    className="network-label-text"
                >
                    {count.balls}-{count.strikes}
                </text>
                {arcs.map((arcValue, i) => {
                    const path = makeArc(arcValue)

                    return (
                        <path
                            key={`network_pie_${i}`}
                            transform={`translate(${maxCircleSize / 2},${
                                maxCircleSize / 2
                            })`}
                            d={path}
                            fill={Color('pitchName', arcValue.data.name)}
                            stroke="#000"
                            onMouseOver={(event) => {
                                const html = `<div><b>Pitch Type</b>: ${
                                    arcValue.data.pitchName
                                }<br/>${arcValue.data.total} ${
                                    arcValue.data.total > 1
                                        ? `Pitches`
                                        : `Pitch`
                                }<br>${Number(
                                    arcValue.data.value * 100
                                ).toFixed(1)}%</div>`
                                handleMouseOver(event, html)
                            }}
                            onMouseOut={(event) => {
                                handleMouseOut(event, null)
                            }}
                        />
                    )
                })}
            </g>
        )
    })

    connections.map((line, i) => {
        const lineStart = find(xyLocations, (d) => d.layer === line[0])
        const lineEnd = find(xyLocations, (d) => d.layer === line[1])

        elements.unshift(
            <g key={`connection_${i}`}>
                <line
                    x1={lineStart.x}
                    y1={lineStart.y}
                    x2={lineEnd.x}
                    y2={lineEnd.y}
                    stroke="#c2c2c2"
                    strokeWidth={1}
                />
            </g>
        )
    })

    return (
        <>
            <g id="network">{elements}</g>
            {chartOptions.scaleRadius ? (
                <NetworkPieLegend
                    settings={settings}
                    radiusScale={scaleCircle.range([
                        minCircleSize / 2,
                        maxCircleSize / 2,
                    ])}
                />
            ) : null}
        </>
    )
}
